import { styled } from "@mui/material/styles";
import { Box, Typography, Button } from "@mui/material";
import { keyframes } from "@emotion/react";

export const ModalOverlay = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1400,
  backdropFilter: "blur(4px)",
}));

export const ModalContainer = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.shape.borderRadius * 2,
  padding: theme.spacing(3),
  maxWidth: 400,
  width: "90%",
  position: "relative",
  zIndex: 1401,
  boxShadow: theme.shadows[4],
  maxHeight: "90vh",
  overflowY: "auto",
}));

export const ModalContent = styled(Box)({
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  width: "100%",
});

export const ModalIcon = styled(Box)(({ theme, type }) => ({
  width: 52,
  height: 52,
  borderRadius: "50%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: 24,
  marginBottom: 16,
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shorter,
  }),
  backgroundColor:
    type === "success"
      ? theme.palette.success.light
      : type === "error" ? theme.palette.error.light
        : theme.palette.warning.main,
  color:
    type === "success" ? theme.palette.success.main : type === "error" ? theme.palette.error.main : theme.palette.common.white,
  border: `2px solid ${type === "success"
    ? theme.palette.success.main + "30"
    : theme.palette.error.main + "30"
    }`,

  "&:hover": {
    transform: "scale(1.05)",
  },
}));

export const ModalTitle = styled(Typography)(({ theme }) => ({
  margin: "0 0 8px 0",
  color: theme.palette.text.primary,
  fontSize: 18,
  fontWeight: 600,
  letterSpacing: "-0.01em",
}));

export const ModalMessage = styled(Typography)(({ theme }) => ({
  margin: "0 0 20px 0",
  color: theme.palette.text.secondary,
  fontSize: 13,
  lineHeight: 1.5,
  maxWidth: "100%",
  wordBreak: "break-word",
  overflowWrap: "break-word",
  whiteSpace: "pre-line",
}));

export const ModalButton = styled(Button)(({ theme, type }) => ({
  padding: "10px 20px",
  borderRadius: theme.shape.borderRadius,
  fontSize: 13,
  fontWeight: 500,
  cursor: "pointer",
  minWidth: 120,
  backgroundColor:
    type === "success" ? theme.palette.success.main : type === "error" ? theme.palette.error.main
      : theme.palette.warning.main,
  color: theme.palette.common.white,
  boxShadow: `0 2px 8px ${type === "success"
    ? theme.palette.success.main + "40"
    : type === "error" ? theme.palette.error.main + "40"
      : theme.palette.warning.main + "40"
    }`,

  "&:hover": {
    backgroundColor:
      type === "success"
        ? theme.palette.success.dark
        :  type ==="error"? theme.palette.error.dark
      : theme.palette.warning.dark,
    transform: "translateY(-1px)",
    boxShadow: `0 4px 12px ${type === "success"
      ? theme.palette.success.main + "40"
      : type === "error" ? theme.palette.error.main + "40"
        : theme.palette.warning.main + "40"
      }`,
  },

  "&:active": {
    transform: "translateY(0)",
    boxShadow: `0 2px 8px ${type === "success"
      ? theme.palette.success.main + "40"
      : type === "error" ? theme.palette.error.main + "40"
        : theme.palette.warning.main + "40"
      }`,
  },
}));
